import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import * as yup from 'yup';

import { TextField } from 'src/shared/components/forms';
import { useSingleSignOn, useTranslate } from 'src/shared/hooks';
import { TranslationNamespace } from 'src/shared/hooks/useTranslate';
import { logFactory } from 'src/shared/log';

const log = logFactory('login:components:EmailSingleSignOnInput');
const emailSchema = yup.string().required().email();

interface EmailFormData {
  email: string;
}

const EmailSingleSignOnInput = () => {
  const t = useTranslate(TranslationNamespace.LOGIN);
  const { checkEmail, isActive } = useSingleSignOn();

  // eslint-disable-next-line @typescript-eslint/unbound-method
  const { watch } = useFormContext<EmailFormData>();

  const emailPropName = 'email';
  const email = watch(emailPropName);
  const isEmailValid = emailSchema.isValidSync(email);

  useEffect(() => {
    if (!isActive && isEmailValid && checkEmail) {
      log('🔍 Checking email...', email);
      void checkEmail(email);
    }
  }, [checkEmail, email, isActive, isEmailValid]);

  return (
    <TextField
      iconBefore={faEnvelope}
      label={t('email')}
      name={emailPropName}
      placeholder={t('email')}
      type="email"
    />
  );
};

export { EmailSingleSignOnInput };
